import { iconUri } from '@nerdwallet/nw-client-lib/cdn';

const config = {
  cards: [
    {
      header: 'Tools',
      text: 'Choose from over 25 mortgage tools',
      img: iconUri('Calculator'),
      alt: 'Calculator',
      link: {
        url: '/blog/mortgages/mortgage-tools-calculators',
        text: 'Mortgage calculators',
      },
    },
    {
      header: 'Calculators',
      text: 'Calculate your refinance savings',
      img: iconUri('House_pricetag'),
      alt: 'house icon',
      link: {
        url: '/mortgages/refinance-calculator',
        text: 'Refinance calculator',
      },
    },
    {
      header: 'Calculators',
      text: 'Calculate how much you can borrow',
      img: iconUri('Credit_score'),
      alt: 'Credit score gauge',
      link: {
        url: '/blog/mortgages/home-equity-loan-calculator/',
        text: 'Home equity loan calculator',
      },
    },
    {
      header: 'Credit',
      text: 'Get your true budget and find a home with ease.',
      img: iconUri('Scale'),
      alt: 'Old weighing scale',
      link: {
        url: '/home/dashboard/credit-score',
        text: 'Get your free credit score',
      },
    },
  ],
};
export default config;
